// sagas.js
import { call, put, takeLatest } from "redux-saga/effects";
import {
  resumeDataSuccess,
  resumeDataFailure,
} from "./actions";
import { RESUME_DATA_REQUEST, } from "../../actionTypes";
import AxiosInstance from "../../../services/AxiosInstance";

function* getResumeData(action) {
  console.log("action44", action);
  const formData = new FormData();
  // 'resume' should match what your backend expects
  formData.append('resume', action.payload);
  try {
    const response = yield call(() =>
      AxiosInstance().post("/recruiter/get_resumes_data", formData)
    );
    console.log(response);
    yield put(resumeDataSuccess(response.data));
  } catch (error) {
    yield put(resumeDataFailure(error));
  }
}

function* getResumeDataSaga() {
  yield takeLatest(RESUME_DATA_REQUEST, getResumeData);
}

export default getResumeDataSaga;
